import type { AutomationCategoryResponse } from '@reach/shared-types/automation-category';
import type {
  EngageLibraryItemTypeEnum,
  EngageLibrarySyncActionEnum,
  EngageLibrarySyncResult,
  TenantEngageLibrary,
} from '@reach/shared-types/engage-library';
import { TenantSyncStateEnum } from '@reach/shared-types/tenant-filter';

export {
  EngageLibraryItemTypeEnum,
  EngageLibraryJobStatusEnum,
  EngageLibrarySyncActionEnum,
  EngageLibrarySyncFailureReasonEnum,
  EngageLibrarySyncStatusEnum,
} from '@reach/shared-types/engage-library';

export type {
  EngageLibraryJobStatusResponse,
  EngageLibrarySyncRequest,
  EngageLibrarySyncResponse,
  EngageLibrarySyncResult as EngageLibrarySyncResultItem,
  TenantEngageLibrary as EngageLibraryResponse,
} from '@reach/shared-types/engage-library';

export type EngageLibraryItemType = EngageLibraryItemTypeEnum;

export interface EngageLibraryBatchedSyncResponse {
  results: EngageLibrarySyncResult[];
  jobIds: string[];
  /** Positions, in the order sent, of requests whose outcome could not be confirmed. */
  failedRequestIndexes: number[];
  failureMessage: string | undefined;
}

export interface EngageLibraryRowModel {
  id: string;
  type: EngageLibraryItemType;
  name: string;
  description: string | null;
  updatedAt: string | null;
  tenantSyncState: TenantSyncStateEnum;
  /** True when another template sync can recover this row. Execution failures stay false. */
  retryable: boolean;
  /** False for a required system segment, such as All Users, that the tenant must keep. */
  removable: boolean;
  /** Always empty for segments, which have no categories. */
  categories: AutomationCategoryResponse[];
}

export enum MembershipLockReasonEnum {
  REQUIRED_SEGMENT = 'required_segment',
  SYNCING = 'syncing',
}

export interface PendingMembershipChange {
  row: EngageLibraryRowModel;
  action: EngageLibrarySyncActionEnum;
}

export type EngageStatusFilter = 'all' | TenantSyncStateEnum;

export interface EngageLibraryFilters {
  search: string;
  statusFilter: EngageStatusFilter;
  /** Rows with any of these categories match; an empty list matches every row. */
  categoryIds: string[];
}

export const EMPTY_ENGAGE_LIBRARY: TenantEngageLibrary = { automations: [], segments: [] };
